<template>
  <q-page fluid class="row">
    <div class="row full-width">
      <!-- timeLeft -->
      <!-- {{ $moment(timeLeftInScan * 1000).format("mm:ss") }} -->
      <!-- <div class="col-12 col-md-6 q-pa-sm">
        <scannedSurveys :actionOpensReport="false" @viewReport="loadReport" />
      </div>
      <div class="col-12 col-md-6 q-pa-sm">
        <scheduledSurveys />
      </div> -->
    </div>
  </q-page>
</template>

<script>
  // import VueApexCharts from "vue-apexcharts";

  import { mapGetters } from "vuex";
  import scannedSurveys from "@/components/scheduledSurveys/scannedSurveys.vue";
  import scheduledSurveys from "@/components/scheduledSurveys/scheduledSurveys.vue";
  import pastSurveysClustorMap from "@/components/scheduledSurveys/pastSurveysClustorMap.vue";
  import surveyMapReport from "@/components/surveyReport/surveyMapReport.vue";
  import surveyDataReport from "@/components/surveyReport/surveyDataReport.vue";

  import moment from "moment";

  export default {
    components: {
      scannedSurveys,
      scheduledSurveys,
      pastSurveysClustorMap,
      surveyMapReport,
      surveyDataReport,
    },
    computed: {
      ...mapGetters(["currentUser"]),
    },
    props: {
      source: String,
    },
    watch: {},
    data: () => ({
      reportView: false,
      reportID: null,
      timeLeftInScan: 0,
      currentScanStartTime: 1643255434029,
    }),
    mounted() {
      // this.setTimeLeftInScan();
    },
    methods: {
      setTimeLeftInScan() {
        console.log(Date.now());
        setInterval(() => {
          this.timeLeftInScan =
            1140 - (Date.now() - this.currentScanStartTime) / 1000;
        }, 900);
      },
      loadReport(survey) {
        this.reportView = true;
        this.reportID = survey.id;
      },
      gmapPanToLocation(pos) {
        this.$refs.gmap.updateCenterPOS(pos);
      },
      dotClicked(point) {
        this.$refs.reportData.dotClicked(point);
      },
    },
  };
</script>
